"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useNormalHeaderStyle = (showBackBtn, AuthComponent) => {
    const theme = (0, material_1.useTheme)();
    const layoutContainer = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: AuthComponent ? '2rem' : 0,
    };
    const normalHeader = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: showBackBtn ? 'space-between' : 'flex-end',
        flexDirection: 'row',
        padding: '1rem 1.5rem',
        maxWidth: '552px',
        width: '100%',
        '& button': {
            background: 'transparent',
        },
        '&>div': {
            display: 'flex',
            alignItems: 'center',
        },
        background: 'transparent',
    };
    const backIcon = {
        backgroundColor: theme.qlub.palette.white.main,
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    const main = {
        maxWidth: '552px',
        width: '100%',
    };
    const loginAction = {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        background: 'rgba(255,255,255,0)',
        width: '100%',
        padding: '1rem 1.5rem',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 1000,
        '& button': {
            textTransform: 'lowercase',
            background: theme.qlub.palette.white.main,
            '&:hover': {
                background: theme.qlub.palette.white.main,
            },
        },
    };
    return {
        layoutContainer,
        normalHeader,
        backIcon,
        main,
        loginAction,
    };
};
exports.default = useNormalHeaderStyle;
